import React, { useCallback, useEffect, useState } from 'react';

import { Button, Modal } from 'antd';
import { useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { getStringsKey } from 'lib/modalConfig';
import { getIntlStrings } from 'locales/i18n/localeHelpers';

import { CampaignModal } from './campaigns/CampaignModal';
import RedirectsList from './campaigns/RedirectsList';
import { Actions } from '../../../../actions';
import Box from '../../../common/Box';
import { LargeModalForRedux } from '../../../common/ModalForRedux';
import OnBoardingPage from '../../onBoarding/onBoarding';

const StyledBox = styled(Box).withConfig({
  displayName: 'StyledBox',
})`
  margin-bottom: 1em;
`;

const CampaignName = styled.span.withConfig({ displayName: 'CampaignName' })`
  color: var(--text-muted);
  margin-bottom: 7px;
  display: inline-block;
`;

const ModalsCampaign = () => {
  const { addCampaignModalConfig, editCampaignModalConfig, deleteCampaignModalConfig } = useSelector((states) => ({
    addCampaignModalConfig: states.front.addCampaignModalConfig,
    editCampaignModalConfig: states.front.editCampaignModalConfig,
    deleteCampaignModalConfig: states.front.deleteCampaignModalConfig,
  }));

  return (
    <>
      <CampaignModal
        mode="add"
        config={addCampaignModalConfig}
        actionSuccess={(payload) => Actions.api.audienceBuilder.campaigns.add.request(payload)}
        actionCancel={(payload) => Actions.front.audienceBuilder.campaigns.add.hide.request(payload)}
      />

      <CampaignModal
        mode="edit"
        config={editCampaignModalConfig}
        actionSuccess={(payload) => Actions.api.audienceBuilder.campaigns.edit.request(payload)}
        actionCancel={(payload) => Actions.front.audienceBuilder.campaigns.edit.hide.request(payload)}
      />
      <LargeModalForRedux
        config={deleteCampaignModalConfig}
        okMessage={getIntlStrings(`${getStringsKey(deleteCampaignModalConfig)}.delete.button`)}
        okStyle={{ backgroundColor: 'var(--bad-color)' }}
        okOnly={true}
        actionSuccess={(_) => Actions.api.audienceBuilder.campaigns.delete.request(deleteCampaignModalConfig)}
        actionCancel={(_) => Actions.front.audienceBuilder.campaigns.delete.hide.request(deleteCampaignModalConfig)}
        title={getIntlStrings(`${getStringsKey(deleteCampaignModalConfig)}.delete.title`)}
      >
        {!!deleteCampaignModalConfig.campaignOrSub && (
          <>
            <span>{`${getIntlStrings(`${getStringsKey(deleteCampaignModalConfig)}.title`)}: `}</span>
            <CampaignName>{deleteCampaignModalConfig.campaignOrSub.name}</CampaignName>
            <div style={{ color: 'var(--text-muted)' }}>
              {getIntlStrings(`${getStringsKey(deleteCampaignModalConfig)}.delete.help`)}
            </div>
          </>
        )}
      </LargeModalForRedux>
    </>
  );
};

const WelcomeToPixelMeModal = ({ account }) => {
  const location = useLocation();
  const history = useHistory();
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    setShowPopup(params.has('invited'));
  }, [location.search]);

  const close = useCallback(() => {
    const params = new URLSearchParams(location.search);

    params.delete('invited');

    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    });

    setShowPopup(false);
  }, [history, location]);

  return (
    <Modal
      visible={showPopup}
      title="Welcome to PixelMe!"
      width={352}
      onCancel={close}
      footer={
        <Button type="primary" onClick={close}>
          Get Started
        </Button>
      }
    >
      <div>
        You&apos;ve joined the {account.name} workspace in the {account.organizationName} organization.
      </div>
    </Modal>
  );
};

const Campaigns = ({ account }) => {
  const { displayOnboarding } = useSelector((states) => ({
    displayOnboarding: !(states.accounts.usage.shortens > 0),
  }));

  return (
    <>
      <WelcomeToPixelMeModal account={account} />
      <StyledBox>
        {displayOnboarding ? (
          <>
            <OnBoardingPage></OnBoardingPage>
            <ModalsCampaign />
          </>
        ) : (
          <RedirectsList account={account} />
        )}
      </StyledBox>
    </>
  );
};

export default Campaigns;
